import { useState, useEffect } from 'react';
import { Box, Typography, Slide } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import WifiIcon from '@mui/icons-material/Wifi';

export default function NetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowReconnected(true);
      setTimeout(() => setShowReconnected(false), 3000);
    };
    const handleOffline = () => {
      setIsOnline(false);
      setShowReconnected(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline && !showReconnected) return null;

  return (
    <Slide direction="down" in={!isOnline || showReconnected}>
      <Box
        role="alert"
        aria-live="assertive"
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          py: 0.75,
          px: 2,
          bgcolor: isOnline ? 'success.main' : 'error.main',
          color: '#fff',
        }}
      >
        {isOnline ? (
          <>
            <WifiIcon fontSize="small" />
            <Typography variant="body2" fontWeight={500}>
              Back online
            </Typography>
          </>
        ) : (
          <>
            <WifiOffIcon fontSize="small" />
            <Typography variant="body2" fontWeight={500}>
              You are offline. Some features may not be available.
            </Typography>
          </>
        )}
      </Box>
    </Slide>
  );
}
